// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._31j0G6Xr980QZG {\n  margin-bottom: 0;\n  margin-left: auto;\n}\n.dkrXhLP4rbGCL5 {\n  background: #EBECF0;\n}\n.qeDkOT4m3GGt2V {\n  margin: 0 12px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"templateCardBannerButton": "_31j0G6Xr980QZG",
	"popover": "dkrXhLP4rbGCL5",
	"popoverPadding": "qeDkOT4m3GGt2V"
};
export default ___CSS_LOADER_EXPORT___;
